import React from 'react';
import { MapPin, Globe2 } from 'lucide-react';
import { brand } from '../mock';

const TopTicker = () => {
  return (
    <div className="w-full border-b border-white/5 bg-[#0a1120]/90 backdrop-blur-sm text-[11px] font-mono">
      <div className="max-w-[1320px] mx-auto px-6 flex items-center justify-between h-9">
        <div className="flex items-center gap-3 text-slate-300">
          <span className="inline-flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
            <span className="tracking-[0.14em] text-emerald-300/90">{brand.ticker}</span>
          </span>
          <span className="text-slate-600">|</span>
          <span className="text-slate-400 tracking-wide">{brand.tickerNote}</span>
        </div>
        <div className="hidden md:flex items-center gap-4 text-slate-400">
          <span className="inline-flex items-center gap-1.5"><Globe2 className="w-3 h-3 text-emerald-400/80" /> {brand.scope}</span>
          <span className="text-slate-700">|</span>
          <span className="inline-flex items-center gap-1.5"><MapPin className="w-3 h-3 text-orange-400/80" /> {brand.location}</span>
        </div>
      </div>
    </div>
  );
};

export default TopTicker;
